(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kompac-service-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const selectors = {
      section: '.kompac-service-grid',
      scroller: '.kompac-service-grid__items',
    };

    const initAutoScroll = (section) => {
      const scroller = section.querySelector(selectors.scroller);

      if (!scroller || scroller.dataset.autoScrollInit === 'true') return;

      let frameId = null;
      let resumeTimer = null;
      let lastTime = 0;
      let paused = false;

      const canScroll = () =>
        mobileQuery.matches &&
        !reduceMotionQuery.matches &&
        scroller.scrollWidth > scroller.clientWidth + 1;

      const stop = () => {
        if (frameId) {
          window.cancelAnimationFrame(frameId);
          frameId = null;
        }
        lastTime = 0;
      };

      const tick = (time) => {
        if (!canScroll() || paused) {
          stop();
          return;
        }

        if (!lastTime) lastTime = time;

        const elapsed = time - lastTime;
        lastTime = time;
        scroller.scrollLeft += elapsed * 0.025;

        if (scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 1) {
          scroller.scrollLeft = 0;
        }

        frameId = window.requestAnimationFrame(tick);
      };

      const start = () => {
        if (!frameId && canScroll() && !paused) {
          frameId = window.requestAnimationFrame(tick);
        }
      };

      const pauseTemporarily = () => {
        paused = true;
        stop();
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(() => {
          paused = false;
          start();
        }, 2200);
      };

      scroller.addEventListener('pointerdown', pauseTemporarily, { passive: true });
      scroller.addEventListener('touchstart', pauseTemporarily, { passive: true });
      scroller.addEventListener('wheel', pauseTemporarily, { passive: true });
      window.addEventListener('resize', start);
      mobileQuery.addEventListener('change', start);
      reduceMotionQuery.addEventListener('change', start);

      scroller.dataset.autoScrollInit = 'true';
      start();
    };

    const initSections = (root = document) => {
      root.querySelectorAll(selectors.section).forEach(initAutoScroll);
    };

    initSections();
    document.addEventListener('shopify:section:load', (event) => initSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
